import { useCallback, useContext, useEffect } from "react";
import { GlobalContext } from "../components/GlobalContext";
import { useDataChannel } from "@livekit/components-react";
import { ReceivedMessage } from "../types";
import useUser from "./user";

const decoder = new TextDecoder();

export const useChatMessages = () => {
  const context = useContext(GlobalContext);
  return [context.messages, context.setMessages] as const;
};
// Update chat messages
export const useListenForChatMessages = () => {
  const [, setMessages] = useChatMessages();
  const [user] = useUser();

  useDataChannel(
    "chat",
    useCallback(
      (data: { payload: Uint8Array }) => {
        const newMsg = JSON.parse(
          decoder.decode(data.payload)
        ) as ReceivedMessage;

        setMessages((prev) => {
          if (newMsg.identity === user.livekitId) {
            return prev.map((oldMsg) =>
              oldMsg.messageId === newMsg.messageId
                ? { ...newMsg, pending: false }
                : oldMsg
            );
          }
          return [...prev, newMsg];
        });
      },
      [setMessages, user.livekitId]
    )
  );

  // Clear messages when component which uses Chat unmounts
  useEffect(() => {
    return () => {
      setMessages([]);
    };
  }, [setMessages]);
};
